import { render, staticRenderFns } from "./LivingOptionsPropertyModels.vue?vue&type=template&id=113410a7"
import script from "./LivingOptionsPropertyModels.vue?vue&type=script&lang=js"
export * from "./LivingOptionsPropertyModels.vue?vue&type=script&lang=js"
import style0 from "./LivingOptionsPropertyModels.vue?vue&type=style&index=0&id=113410a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports